import { BasePayloadMapper } from '@ps/utils';
import { SupplierGroupTemplatePayloadDto } from '../dtos/supplier-group-template.dto';
import { SupplierGroupTemplateSave } from '../../models/supplier-group-template.model';

export class SupplierGroupTemplatePayloadMapper extends BasePayloadMapper<
  SupplierGroupTemplateSave,
  SupplierGroupTemplatePayloadDto
> {
  public toPayload(
    model: SupplierGroupTemplateSave,
  ): SupplierGroupTemplatePayloadDto {
    return {
      groupName: model.groupName,
      allocation: model.allocation ?? 0,
      is_custom_allocation: model.isCustomAllocation,
      suppliers: model.members.map((member) => ({
        id: member.id,
        name: member.name,
        allocation: member.allocation,
      })),
    };
  }
}
